import { gql } from '@apollo/client'

export const CREATE_CHARTER_BOAT_CONFIG = gql`
    mutation CreateCharterBoatConfig($input: CharterBoatConfigInput!) {
        createCharterBoatConfig(input: $input) {
            code
            success
            message
            configuration {
                id
            }
        }
    }
`

export const UPDATE_CHARTER_BOAT_CONFIG = gql`
    mutation UpdateCharterBoatConfig($id: String!, $input: CharterBoatConfigInput!) {
        updateCharterBoatConfig(id: $id, input: $input) {
            code
            success
            message
            configuration {
                id
            }
        }
    }
`

export const DELETE_CHARTER_BOAT_CONFIG = gql`
    mutation DeleteCharterBoatConfig($id: String!) {
        deleteCharterBoatConfig(id: $id) {
            code
            success
            message
        }
    }
`

export const CREATE_CHARTER_BOAT_PRICE = gql`
    mutation CreateCharterBoatConfig($charterBoatConfig: CharterBoatConfigInput!) {
        createCharterBoatConfig(charter_boat_config: $charterBoatConfig) {
            code
            success
            message
        }
    }
`

export const UPDATE_CHARTER_BOAT_PRICE = gql`
    mutation UpdateCharterBoatConfig($configId: NonEmptyString!, $charterBoatConfig: CharterBoatConfigInput!) {
        updateCharterBoatConfig(config_id: $configId, charter_boat_config: $charterBoatConfig) {
            code
            success
            message
        }
    }
`
export const UPDATE_CHARTER_BOAT_BOOKING = gql`
    mutation updateCharterBoatBooking($booking: CharterBoatBookingModificationInput!) {
        updateCharterBoatBooking(booking: $booking) {
            code
            success
            message
            booking {
                booking_id
                total_price
                booking_code
                payment_channel
                payment_preference {
                    payment_channel
                    return_url
                    deduction {
                        use_wallet
                        promo_code
                    }
                }
                price {
                    final_price
                    total
                    payable
                    deduction {
                        wallet
                    }
                    price_summary {
                        price_type
                        type {
                            en
                            ar
                        }
                        unit_no
                        unit_price
                        total_price
                    }
                    price_summary_total
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                trip_segments {
                    segment_id
                    travel_date
                    booking_id
                    route_id
                    trip_id
                    trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        route_id
                        start_time
                        end_time
                    }
                    start {
                        location_id
                        stop_number
                        arrival_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    end {
                        location_id
                        stop_number
                        arrival_time
                        departure_time
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                    }
                    segment_order
                }
            }
        }
    }
`

export const UPDATE_CHARTER_BOAT_ROUTE_PRICE = gql`
    mutation UpdateCharterBoatRoutePrice($routeId: NonEmptyString!, $prices: [CharterBoatRoutePriceInput!]!) {
        updateCharterBoatRoutePrice(route_id: $routeId, prices: $prices) {
            code
            success
            message
        }
    }
`

export const CHARTER_BOAT_BOOKING_STATUS = gql`
    mutation UpdateCharterBoatBookingStatus($bookingId: NonEmptyString!, $statusCode: CharterBoatBookingStatusEnum!) {
        updateCharterBoatBookingStatus(booking_id: $bookingId, status_code: $statusCode) {
            code
            success
            message
        }
    }
`
